import script from "./DisconnectGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DisconnectGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./DisconnectGuideModal.vue?vue&type=style&index=0&id=c524f5e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c524f5e8"]])

export default __exports__